import { Box, Typography, List, ListItem, ListItemText, Divider, Chip } from '@mui/material'
import calendarImg from '../media/calendar.png'

interface CalendarEvent {
  date: string
  description: string
  type: 'tuition' | 'noschool' | 'event' | 'holiday'
}

const CALENDAR_EVENTS: CalendarEvent[] = [
  { date: '8/1', description: 'Tuition Remainder Due', type: 'tuition' },
  { date: '8/9', description: 'Back To Farmschool', type: 'event' },
  { date: '8/17 & 18', description: 'First Days of Farmschool and Miss Sabrina Birthday Parties!', type: 'event' },
  { date: '9/1', description: 'Tuition Due', type: 'tuition' },
  { date: '9/7', description: 'Labor Day — School in session', type: 'holiday' },
  { date: '10/1', description: 'Tuition Due', type: 'tuition' },
  { date: '10/26 & 27', description: 'Fall Farmschool Fest', type: 'event' },
  { date: '10/28 & 29', description: 'NO SCHOOL', type: 'noschool' },
  { date: '11/1', description: 'Tuition Due', type: 'tuition' },
  { date: '11/11', description: 'Veterans Day — School in session', type: 'holiday' },
  { date: '11/23–11/26', description: 'NO SCHOOL — Fall Break', type: 'noschool' },
  { date: '12/1', description: 'Tuition Due', type: 'tuition' },
  { date: '12/14 & 15', description: 'Christmas Parties', type: 'event' },
  { date: '12/16–12/31', description: 'NO SCHOOL', type: 'noschool' },
  { date: '1/1', description: 'Tuition Due', type: 'tuition' },
  { date: '1/4 & 5', description: 'School Resumes', type: 'event' },
  { date: '2/1', description: 'Tuition Due', type: 'tuition' },
  { date: '2/10 & 11', description: 'Valentines Day Parties', type: 'event' },
  { date: '3/1', description: 'Tuition Due & March Manners', type: 'tuition' },
  { date: '3/17 & 18', description: 'ST. Pats Parties', type: 'event' },
  { date: '3/22–3/25', description: 'NO SCHOOL — Spring Break', type: 'noschool' },
  { date: '3/31 & 4/1', description: 'March Manners Parties / Easter / School Photos', type: 'event' },
  { date: '4/1', description: 'Tuition Due', type: 'tuition' },
  { date: '5/1', description: 'Tuition Due', type: 'tuition' },
  { date: '5/10 & 11', description: 'Graduation Celebrations and Last Day of School', type: 'event' },
]

const TYPE_COLORS: Record<CalendarEvent['type'], 'warning' | 'error' | 'success' | 'default'> = {
  tuition: 'warning',
  noschool: 'error',
  event: 'success',
  holiday: 'default',
}

const TYPE_LABELS: Record<CalendarEvent['type'], string> = {
  tuition: 'Tuition',
  noschool: 'No School',
  event: 'Event',
  holiday: 'Holiday',
}

export default function CalendarPage() {
  return (
    <Box>
      <Typography variant="h5" fontWeight={700} mb={3}>
        Calendar
      </Typography>

      {/* Calendar image */}
      <Box
        component="img"
        src={calendarImg}
        alt="School Year Calendar"
        sx={{
          width: '100%',
          maxWidth: 900,
          display: 'block',
          borderRadius: 2,
          boxShadow: 3,
          mb: 4,
        }}
      />

      {/* Event list */}
      <Typography variant="h6" fontWeight={600} mb={1}>
        Important Dates
      </Typography>

      <List
        disablePadding
        sx={{
          maxWidth: 700,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 1,
          overflow: 'hidden',
        }}
      >
        {CALENDAR_EVENTS.map((event, index) => (
          <Box key={`${event.date}-${index}`}>
            <ListItem
              sx={{
                px: 2.5,
                py: 1.25,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              }}
            >
              <Typography
                variant="body2"
                fontWeight={700}
                sx={{ minWidth: 90, color: 'text.secondary', fontVariantNumeric: 'tabular-nums' }}
              >
                {event.date}
              </Typography>
              <ListItemText
                primary={event.description}
                primaryTypographyProps={{ variant: 'body1' }}
                sx={{ flex: 1, m: 0 }}
              />
              <Chip
                label={TYPE_LABELS[event.type]}
                color={TYPE_COLORS[event.type]}
                size="small"
                variant="outlined"
                sx={{ flexShrink: 0 }}
              />
            </ListItem>
            {index < CALENDAR_EVENTS.length - 1 && (
              <Divider component="li" sx={{ mx: 2 }} />
            )}
          </Box>
        ))}
      </List>
    </Box>
  )
}
